require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-i-before-e-except-after-c.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-i-before-e-except-after-c");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-i-before-e-except-after-c!./.cache/json/coding-interview-prep-rosetta-code-i-before-e-except-after-c.json
// module id = 1902
// module chunks = 231608221292675